// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--27a39";
export var container = "styles-module--container--5ed4b";
export var cta = "styles-module--cta--b8753";
export var description = "styles-module--description--78e94";
export var header = "styles-module--header--3a2eb";
export var image = "styles-module--image--472cf";
export var logoContainer = "styles-module--logoContainer--01913";
export var marquee = "styles-module--marquee--dbe61";
export var section = "styles-module--section--31df3";
export var title = "styles-module--title--315ca";
export var visible = "styles-module--visible--ddf67";